export default __webpack_public_path__ + "img/i-map-menu.4359cc40.svg";